exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.page-content[data-v-15e0ae04] {\r\n  transform: translate3d(0, 0, 0);\r\n  -webkit-transform: translate3d(0, 0, 0);\r\n  transition-duration: 0.3s;\r\n  overflow: hidden !important;\r\n  background-color: #000;\n}\n.slider-caption[data-v-15e0ae04] {\r\n  transform: translate3d(0, 0, 0);\r\n  -webkit-transform: translate3d(0, 0, 0);\r\n  transition-duration: 0.3s;\n}\n.slider-caption > span[data-v-15e0ae04] {\r\n  color: white;\n}\n.active span[data-v-15e0ae04] {\r\n  display: block;\n}\n.swiper-pagination[data-v-15e0ae04] {\r\n  left: 50%;\r\n  transform: translateX(-50%);\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-15e0ae04","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/home-page-components/varius-component.vue
// module id = 553
// module chunks = 0